import { Modal } from "@js/components/modal";

export const PostJobForClientModalInstance = Modal("post-job-for-a-client", {
  closeButton: false,
  keepOnBackdropClick: true,
  disableEscapeKeyDown: true,
  disablePortal: true,
});
